/**
 * @fileoverview
 * Error Logger Service - Logs errors for monitoring
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface ErrorLog {
  timestamp: Date;
  message: string;
  stack?: string;
  url?: string;
  statusCode?: number;
  userAgent: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggerService {
  private errorLogs: ErrorLog[] = [];

  /**
   * Log error
   */
  logError(error: Error | HttpErrorResponse): void {
    const errorLog = this.createErrorLog(error);
    
    // Store in memory
    this.errorLogs.push(errorLog);

    // Log to console in development
    if (environment.enableLogging) {
      console.error('[Error Log]:', errorLog);
    }

    // In production, send to monitoring service
    if (environment.production) {
      this.sendToMonitoringService(errorLog);
    }
  }

  /**
   * Get all error logs
   */
  getErrorLogs(): ErrorLog[] {
    return [...this.errorLogs];
  }

  /**
   * Clear error logs
   */
  clearErrorLogs(): void {
    this.errorLogs = [];
  }

  /**
   * Create error log object
   */
  private createErrorLog(error: Error | HttpErrorResponse): ErrorLog {
    const log: ErrorLog = {
      timestamp: new Date(),
      message: error.message,
      userAgent: navigator.userAgent,
    };

    if (error instanceof HttpErrorResponse) {
      log.url = error.url || undefined;
      log.statusCode = error.status;
    } else {
      log.stack = error.stack;
    }

    return log;
  }

  /**
   * Send error to monitoring service (Sentry, LogRocket, etc.)
   */
  private sendToMonitoringService(errorLog: ErrorLog): void {
    // TODO: Implement integration with monitoring service
    // Example: Sentry.captureException(error);
    console.log('[Monitoring Service]:', errorLog);
  }
}

